(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-confirm.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-confirm.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Button = svs.ui.ReactButton;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  Inputv2 = _svs$ui$reactForm.Inputv2,
  ControlGroup = _svs$ui$reactForm.ControlGroup;
const _svs$myProfile$react$ = svs.myProfile.react.store.pdPreferences.actions,
  postConfirmMobileNumber = _svs$myProfile$react$.postConfirmMobileNumber,
  getCustomersPreferences = _svs$myProfile$react$.getCustomersPreferences,
  setForceSaveMobile = _svs$myProfile$react$.setForceSaveMobile;
const _svs$myProfile$consta = svs.myProfile.constants.thunkStatus,
  FULFILLED = _svs$myProfile$consta.FULFILLED,
  REJECTED = _svs$myProfile$consta.REJECTED;
const putSendMobileVerificationCodeAsync = svs.myProfile.react.pages.myInformation.myInformationService.putSendMobileVerificationCodeAsync;
const _svs$myProfile$react$2 = svs.myProfile.react.shared.dialogs,
  showTechnicalError = _svs$myProfile$react$2.showTechnicalError,
  showMobileConfirmedDialog = _svs$myProfile$react$2.showMobileConfirmedDialog,
  showMobileConfirmedFlash = _svs$myProfile$react$2.showMobileConfirmedFlash,
  showMobileVerificationCodeSent = _svs$myProfile$react$2.showMobileVerificationCodeSent;
const DEFAULT_ERROR_MESSAGE = 'Koden ska bestå av fyra siffror.';
const trackEventVerify = (verify, callback) => {
  const track = {
    category: 'My Profile',
    action: 'mobile verify',
    opt_label: verify ? 'Yes' : 'No'
  };
  if (callback) {
    svs.components.analytics.trackEvent(track, callback);
  } else {
    svs.components.analytics.trackEvent(track);
  }
};

const MobileConfirm = () => {
  const dispatch = ReactRedux.useDispatch();
  const location = ReactRouterDOM.useLocation();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences),
    cellphone = _ReactRedux$useSelect.cellphone,
    cid = _ReactRedux$useSelect.cid;
  const _ReactRedux$useSelect2 = ReactRedux.useSelector(state => state.playerPreferences.playerPreferencesStatus),
    playerPreferencesStatus = _ReactRedux$useSelect2.status;
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    code = _React$useState2[0],
    setCode = _React$useState2[1];
  const _React$useState3 = React.useState(DEFAULT_ERROR_MESSAGE),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    inputErrorMessage = _React$useState4[0],
    setInputErrorMessage = _React$useState4[1];
  const _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isInputError = _React$useState6[0],
    setIsInputError = _React$useState6[1];
  const _React$useState7 = React.useState(''),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    returnUrl = _React$useState8[0],
    setReturnUrl = _React$useState8[1];
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  React.useEffect(() => {
    var _queryStringObject;
    let queryStringObject = svs.utils.url.queryString;
    if ('URLSearchParams' in window) {
      const urlParamsFunctions = new URLSearchParams(location.search);
      queryStringObject = {
        returnUrl: urlParamsFunctions.get('returnUrl'),
        cancelUrl: urlParamsFunctions.get('cancelUrl')
      };
    }
    if ((_queryStringObject = queryStringObject) !== null && _queryStringObject !== void 0 && _queryStringObject.returnUrl) {
      setReturnUrl(queryStringObject.returnUrl);
    }
  }, [location.search]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED || playerPreferencesStatus === REJECTED) {
      if (!cid) {
        showTechnicalError();
      }
    }
  }, [cid, playerPreferencesStatus]);
  const navigateToReturnUrl = () => {
    svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
  };

  const setInputErrorAndMessage = message => {
    setInputErrorMessage(message);
    setIsInputError(true);
  };

  const handleMobileConfirmError = errorCode => {
    switch (errorCode) {
      case null:
        break;
      case 12520:
        setInputErrorAndMessage('Koden du angav är gammal.');
        break;
      case 12500:
        setInputErrorAndMessage('Koden du angav är felaktig. Prova igen eller skicka ny kod');
        break;
      case 12510:
        showTechnicalError('Dit mobilnummer är redan verifierat', () => {
          navigateToReturnUrl();
        });
        break;
      default:
        svs.myProfile.logger.debug("Unhandled error code when confirming verification sms: ".concat(code));
        showTechnicalError('Ett fel inträffade när koden skulle verifieras, försök igen senare eller kontakta Kundservice 0770 - 11 11 11');
    }
  };

  const handleInputCodeChange = e => {
    if (e.target.value.length <= 4) {
      setCode(e.target.value);
    }
  };

  const handleSendNewCodeClick = async () => {
    try {
      const _await$putSendMobileV = await putSendMobileVerificationCodeAsync(),
        error = _await$putSendMobileV.error;
      if (error) {
        switch (error) {
          case 12010:
            showTechnicalError();
            break;
          case 12015:
            showTechnicalError();
            break;
          case 12016:
            setIsInputError(true);
            break;
          case 12017:
            showTechnicalError();
            break;
          default:
        }
      } else {
        showMobileVerificationCodeSent(cellphone);
      }
    } catch (error) {
      svs.myProfile.logger.warn("Unhandled error code when confirming verification sms: ".concat(error.code));
      showTechnicalError();
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (isNaN(code) || code.length !== 4) {
      setInputErrorMessage(DEFAULT_ERROR_MESSAGE);
      setIsInputError(true);
      return;
    }
    const result = await dispatch(postConfirmMobileNumber(code));
    if (RTK.isFulfilled(result)) {
      if (returnUrl) {
        showMobileConfirmedFlash(cellphone, returnUrl);
        trackEventVerify(true, navigateToReturnUrl);
      } else {
        trackEventVerify(true);
        showMobileConfirmedDialog(cellphone, () => {});
      }
    } else {
      handleMobileConfirmError(result === null || result === void 0 ? void 0 : result.payload.error);
    }
  };
  showMobileConfirmedFlash(cellphone, returnUrl);

  const setForceSaveTrue = () => {
    dispatch(setForceSaveMobile(true));
  };
  return React.createElement("div", null, playerPreferencesStatus === FULFILLED && React.createElement(React.Fragment, null, React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    errorMessage: inputErrorMessage,
    hasError: isInputError,
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    autoComplete: "off",
    id: "smsCode",
    inputHelpText: "4 siffror 0-9",
    label: "Ange kod fr\xE5n SMS",
    name: "sms code",
    onChange: handleInputCodeChange,
    value: code
  })), React.createElement(Button, {
    className: "w100 margin-v-1",
    id: "submitSmsCode",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Bekr\xE4fta")), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: handleSendNewCodeClick,
    transparent: true
  }, "Skicka ny kod"), React.createElement(Button, {
    block: true,
    id: "forceSave",
    onClick: setForceSaveTrue,
    transparent: true
  }, "Ange nytt mobilnummer")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileConfirm = MobileConfirm;

 })(window);